import React from "react";
import styled from "@emotion/styled/macro";
import Cross from "./Cross";
import Deathy from "./Deathy";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  grid-area: ${({ gridArea }) => gridArea};
  justify-content: ${({ placement }) =>
    placement === "left" ? "flex-start" : "flex-end"};
  align-items: ${({ placement }) =>
    placement === "left" ? "flex-start" : "flex-end"};

  > svg {
    flex: 1;
    width: 50px;
    padding: 1rem;
  }
`;

const DeathyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 1rem;
  width: 100px;
  margin-left: -20px;
`;

const Crosses = ({ gridArea, includeDeathy, placement }) => {
  return (
    <Wrapper gridArea={gridArea} placement={placement}>
      <Cross />
      <Cross />
      <Cross />
      <Cross />
      {!includeDeathy && <Cross />}
      {includeDeathy && (
        <DeathyWrapper>
          <Deathy />
        </DeathyWrapper>
      )}
    </Wrapper>
  );
};

export default Crosses;
